import { createReducer, on } from '@ngrx/store';

import * as TransactionActions from './transaction.actions';
import { Transaction } from '../../../core/domain/transaction/transaction';
import { FormMode, IFormMode } from '../../types/IFormMode';

export interface TransactionState {
  isModalOpen: boolean;
  formMode: IFormMode;
  openedTransaction?: Transaction;
}

export const initialState: TransactionState = {
  isModalOpen: false,
  formMode: FormMode.View,
  openedTransaction: undefined,
};

export const transactionReducer = createReducer(
  initialState,

  on(TransactionActions.openTransactionModal, (state, action) => ({
    ...state,
    isModalOpen: true,
    formMode: action.mode,
    openedTransaction: action.transaction || undefined,
  })),
  on(TransactionActions.closeTransactionModal, (state) => ({
    ...state,
    isModalOpen: false,
    formMode: FormMode.New,
    openedTransaction: undefined,
  }))
);
